import i18n from 'i18next';
import { addToast, handleAxiosError } from 'core/notifications';

const handleDataErrors = ({formState, fieldProcessor, error}) => {
  error.response.data?.errors?.forEach(({ message, source }) => {
    const field = fieldProcessor ? fieldProcessor(source) : formState[source.split('data.').pop()];

    if (field) {
      Object.assign(field, { error: message, hasError: true }); // Not best practice as we shouldn't be mutating state directly
    }
  });

  addToast(i18n.t('form-errors'), 'warning');
};

const addErrorsToFormState = ({ formState, fieldProcessor, error }) => {
  switch (error.response?.status) {
    case 403:
      addToast(i18n.t('error-forbidden'), 'error');
      break;
    case 422:
      handleDataErrors({ formState, fieldProcessor, error });
      break;
    default:
      handleAxiosError(error);
      break;
  }
};

export default addErrorsToFormState;
